import { render, staticRenderFns } from "./CustomMenuAction.vue?vue&type=template&id=402a43b4&scoped=true&"
import script from "./CustomMenuAction.vue?vue&type=script&lang=js&"
export * from "./CustomMenuAction.vue?vue&type=script&lang=js&"
import style0 from "./CustomMenuAction.vue?vue&type=style&index=0&id=402a43b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402a43b4",
  null
  
)

export default component.exports